var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2664 5.73361C17.288 4.75542 15.702 4.75547 14.7238 5.73372L6.35872 14.0991C6.07429 14.3836 5.87437 14.7413 5.7812 15.1327L5.01429 18.3534C4.97206 18.5308 5.02486 18.7173 5.15378 18.8463C5.28269 18.9751 5.46926 19.028 5.64661 18.9857L8.86749 18.2189C9.25893 18.1257 9.61683 17.9257 9.90135 17.6412L18.2664 9.27572C19.2445 8.29755 19.2445 6.71173 18.2664 5.73361ZM15.4663 6.47609C16.0344 5.90789 16.9557 5.90787 17.5239 6.47602C18.092 7.04414 18.0921 7.96522 17.5239 8.53336L16.9 9.15732L14.8424 7.09994L15.4663 6.47609ZM14.1 7.84239L16.1576 9.89978L9.15884 16.8988C9.01173 17.0459 8.82668 17.1493 8.62429 17.1975L6.23334 17.7667L6.80265 15.3758C6.85082 15.1736 6.95418 14.9886 7.10123 14.8415L14.1 7.84239Z",
    fill: "#96C11F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.4f474f614ee287ed2ad0633563face3d.svg";
export { ForwardRef as ReactComponent };